import { render } from "./leads-list.vue?vue&type=template&id=4fdb19be&scoped=true"
import script from "./leads-list.vue?vue&type=script&lang=js"
export * from "./leads-list.vue?vue&type=script&lang=js"

import "./leads-list.vue?vue&type=style&index=0&id=4fdb19be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdb19be"]])

export default __exports__